export enum StatusEnum {
  NULL = '',
  INGEVOERD = 'INGEVOERD',
  BEREKEND = 'BEREKEND',
  INGEDIEND = 'INGEDIEND',
}
